import styles from "./MFooter.module.scss"

import PhonePng from "../../assets/images/Phone.png"
import WechatLogoPng from "../../assets/images/WechatLogo.png"
import EnvelopeSimplePng from "../../assets/images/EnvelopeSimple.png"
import MapPinPng from "../../assets/images/MapPin.png"
import footerLogoPng from "../../assets/images/foot_logo.png"
import { PropsWithChildren, ReactNode, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";


export default () => {

    const navigate = useNavigate()
        return (
                <div className={styles['footer']}>
                    <img className={styles['footer__logo']} src={footerLogoPng}></img>
                    <div className={styles['footer__contacts']}>
                        <div className={styles['footer__contact']}>
                            <img className={styles['footer__contact__icon']} src={MapPinPng}></img>
                            <div className={styles['footer__contact__title']}>1401 Mission Street, Ste C-1, South Pasadena, CA, 91030</div>
                        </div>
                        <div className={styles['footer__contact']}>
                            <img className={styles['footer__contact__icon']} src={EnvelopeSimplePng}></img>
                            <div className={styles['footer__contact__title']}>jenny.liu@excelluslaw.com</div>
                        </div>
                        <div className={styles['footer__contact']}>
                            <img className={styles['footer__contact__icon']} src={WechatLogoPng}></img>
                            <div className={styles['footer__contact__title']}>excelluslaw</div>
                        </div>
                        <div className={styles['footer__contact']}>
                            <img className={styles['footer__contact__icon']} src={PhonePng}></img>
                            <div className={styles['footer__contact__title']}>001-626-362-0721</div>
                        </div>

                    </div>
                </div>
            )
}


